__turbopack_context__.v({
  "active": "Drawer-module-scss-module__iVKnFW__active",
  "background": "Drawer-module-scss-module__iVKnFW__background",
  "container": "Drawer-module-scss-module__iVKnFW__container",
});
